import { render, staticRenderFns } from "./ManageAddVeterinaryPatient.vue?vue&type=template&id=436e2478&scoped=true"
import script from "./ManageAddVeterinaryPatient.vue?vue&type=script&lang=js"
export * from "./ManageAddVeterinaryPatient.vue?vue&type=script&lang=js"
import style0 from "./ManageAddVeterinaryPatient.vue?vue&type=style&index=0&id=436e2478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e2478",
  null
  
)

export default component.exports